"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawButton = exports.CSS = void 0;
const theme_1 = require("../theme");
const theme_palette_1 = require("../theme.palette");
const image_button_1 = require("./image.button");
exports.CSS = {
    container: 'c-DrawButton',
    isSelected: 'c-DrawButton--selected',
    solidBackground: 'c-DrawButton--solidBackground',
    isSelectedInsight: 'c-DrawButton--selected-insight',
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        'margin-bottom': theme_1.DefaultTheme.space(2),
        color: theme_1.DefaultTheme.font.color.primary,
        'background-color': theme_1.DefaultTheme.background.offWhite + '99',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp6,
        '&.mdl-button[disabled]': {
            'background-color': theme_1.DefaultTheme.background.offWhite + '99',
        },
        '&:hover': {
            'background-color': theme_palette_1.ColorPalette2022Branding.darkGray + '99',
            color: theme_1.DefaultTheme.font.color.white,
        },
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        '&:focus:not(:active)': {
            border: `2px solid ${theme_1.DefaultTheme.background.darkGrey}`,
            'background-color': theme_palette_1.ColorPalette2022Branding.darkGray + '99',
            color: theme_1.DefaultTheme.font.color.white,
        },
    },
    [exports.CSS.solidBackground]: {
        '&:hover': {
            'background-color': theme_1.DefaultTheme.background.fadedGrey,
        },
        '&:focus:not(:active)': {
            'background-color': theme_1.DefaultTheme.background.fadedGrey,
        },
    },
    [exports.CSS.isSelected]: {
        'background-color': theme_1.DefaultTheme.color.accent,
        '&:focus:not(:active)': {
            'background-color': theme_1.DefaultTheme.color.accent,
        },
        '&:focus:not(:hover)': {
            'background-color': theme_1.DefaultTheme.color.accent,
        },
    },
    [exports.CSS.isSelectedInsight]: {
        color: theme_1.DefaultTheme.font.color.white,
        'background-color': theme_1.DefaultTheme.color.lightIndigo,
        '&:focus:not(:active)': {
            'background-color': theme_1.DefaultTheme.color.lightIndigo,
        },
        '&:focus:not(:hover)': {
            'background-color': theme_1.DefaultTheme.color.lightIndigo,
        },
    },
});
exports.DrawButton = {
    view(icon, ctx = {}) {
        if (ctx.className != null) {
            ctx.className = `${ctx.className} ${exports.CSS.container}`;
        }
        else {
            ctx.className = exports.CSS.container;
        }
        if (ctx.solidBackground) {
            ctx.className += ` ${exports.CSS.solidBackground}`;
        }
        if (ctx.selected) {
            ctx.className = `${ctx.className} ${exports.CSS.isSelected}`;
        }
        if (ctx.hidden) {
            ctx.className = `${ctx.className} hidden`;
        }
        if (ctx.isSelectedInsight) {
            ctx.className = `${ctx.className} ${exports.CSS.isSelectedInsight}`;
        }
        ctx.type = 'button';
        return image_button_1.ImageButton.view(icon, ctx);
    },
};
//# sourceMappingURL=draw.button.js.map